export const flowEventsSectionStyles = {
  eventsPaper: { p: 3, mb: 3 },
  eventsHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    mb: 2,
  },
  schemasHeading: { width: '40%', flexShrink: 0 },
  eventsHeaderMain: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  primaryButton: {
    bgcolor: 'primary.main',
    '&:hover': { bgcolor: 'primary.light' },
  },
  eventsBody: { display: 'flex', gap: 2, alignItems: 'flex-start' },
  eventsList: { flex: 1, minWidth: 0 },
  emptyEvents: {
    p: 4,
    textAlign: 'center',
    color: 'text.secondary',
    border: '1px dashed',
    borderColor: 'divider',
    borderRadius: 1,
  },
  sortableList: { display: 'flex', flexDirection: 'column', gap: 1.5 },
  endZone: {
    minHeight: 36,
    borderRadius: 1,
    mt: 0.5,
  },
};
